<div class="spinner" *ngIf="isLoading">
    <mat-spinner [diameter]="150"></mat-spinner>
</div>
<div class="global_layout">
    <router-outlet></router-outlet>
</div>